import request from "@/api/request";

// 查找好友列表
export function GetFriendList() {
  return request({
    url: "/api/friendApi/selectFriendsByUid",
    method: "post",
  });
}

// 根据输入字段模糊查找好友列表
export function getFriendsByUseridAndKey(params) {
  return request({
    url: "/api/friendApi/getFriendsByUseridAndKey",
    method: "post",
    params: params, // 使用params而不是data
  });
}

export function updateRemark(params) {
  return request({
    url: "/api/friendApi/remark",
    method: "put",
    params: params,
  });
}

//添加好友 myUserId friendUsername
export function requestFriendship(params) {
  return request({
    url: "/api/friendApi/requestFriednship",
    method: "post",
    params: params,
  });
}
//获取用户请求好友列表
export function getUserFriendRequest(params) {
  return request({
    url: "/api/friendApi/getUserFriendRequest",
    method: "post",
    params: params,
  });
}
//通过或拒绝好友请求
export function passOrRejectFriendRequest(params) {
  return request({
    url: "/api/friendApi/passOrRejectFriendRequest",
    method: "post",
    params: params,
  });
}
//查询用户
export function selectByKeyword(data) {
  return request({
    url: "/api/userApi/selectByKeyword",
    method: "post",
    params: data,
  });
}
